import { useTranslation } from 'react-i18next';

import { useModal } from '@/hooks';
import { useAppSelector } from '@/redux/hooks';
import { profileSelectors } from '@/redux/selectors';

import { Button, CopyText, FieldInfoGroup, WebhookModal } from '@/components';

import styles from './WebhookBlock.module.sass';

const WebhookBlock = () => {
  const { t } = useTranslation();
  const { data: profileData } = useAppSelector(
    profileSelectors.getProfileSlice,
  );
  const webhookUrl = useAppSelector(profileSelectors.webhookUrlSetting);
  const {
    isOpen: isOpenWebhookModal,
    onOpenModal: handleOpenWebhookModal,
    onCloseModal: handleCloseWebhookModal,
  } = useModal();

  return (
    <>
      <FieldInfoGroup
        title={t('translation.webhook_label')}
        actions={
          <Button
            type="secondary"
            corner="rect"
            className={styles.actionButton}
            onClick={handleOpenWebhookModal}
          >
            {t('translation.change_webhook_btn')}
          </Button>
        }
      >
        {profileData?.accessKey && (
          <div className={styles.code_block}>
            <div className={styles.row}>
              {webhookUrl ? (
                <>
                  <span className={styles.label}>
                    {t('translation.webhook_url')}:
                  </span>
                  <CopyText
                    className={styles.strong}
                    text={webhookUrl}
                    copyText={webhookUrl}
                  />
                </>
              ) : (
                <span className={styles.label}>
                  {t('translation.webhook_not_set')}
                </span>
              )}
            </div>
          </div>
        )}
      </FieldInfoGroup>

      {isOpenWebhookModal && (
        <WebhookModal
          title={t('translation.support_lnk')}
          onClose={handleCloseWebhookModal}
          isOpen
        />
      )}
    </>
  );
};

export default WebhookBlock;
